export const teamRoutesName = {
    team: "team",
};
